import type { Theme, SxProps } from '@mui/material';

import { useState } from 'react';

import { Box, Tooltip, ButtonBase } from '@mui/material';

import { useOrganisation } from 'src/organisation';

const OrganisationLogoHeader = () => {
  const mediaQuery = 'sm';
  const { organizationName = '', organizationLogo } = useOrganisation();
  const [ratio, setRatio] = useState<number>(1);

  const buttonBg: SxProps<Theme> = {
    height: 1,
    zIndex: -1,
    opacity: 0,
    content: "''",
    borderRadius: 1,
    position: 'absolute',
    visibility: 'hidden',
    bgcolor: 'action.hover',
    width: 'calc(100% + 8px)',
    transition: (theme) =>
      theme.transitions.create(['opacity', 'visibility'], {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.shorter,
      }),
  };

  // Get first letter fallback
  const getInitial = () =>
    organizationName.trim().charAt(0).toUpperCase() || '?';

  return (
    <ButtonBase
      disableRipple
      onClick={() => {}}
      sx={[
        {
          py: 0.5,
          gap: { xs: 0.5, [mediaQuery]: 1 },
          '&::before': buttonBg,
          position: 'relative',
          minWidth: 0,
          overflow: 'hidden',
          maxWidth: {
            xs: 32,
            sm: 140,
            md: 180,
            lg: 220,
            xl: 280,
          },
        },
      ]}
    >
      {organizationLogo ? (
        <Box
        sx={{
          width: Math.min(32 * ratio, 100),
          height: 32,
          flexShrink: 0,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <img
          src={organizationLogo}
          alt={organizationName}
          onLoad={(e) => {
            const img = e.currentTarget;
            setRatio(img.naturalWidth / img.naturalHeight);
          }}
          style={{
            width: '100%',
            height: '100%',
            objectFit: 'contain',
          }}
        />
      </Box>
      ) : (
        <Box
          sx={{
            width: 32,
            height: 32,
            flexShrink: 0,
            borderRadius: '8%',
            bgcolor: 'primary.main',
            color: 'primary.contrastText',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            typography: 'subtitle2',
          }}
        >
          {getInitial()}
        </Box>
      )}

      <Tooltip title={organizationName} enterDelay={600} arrow>
        <Box
          component="span"
          sx={{
            typography: 'subtitle2',
            display: { xs: 'none', [mediaQuery]: 'inline-flex' },
            flex: 1,
            minWidth: 0,
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
          }}
        >
          {organizationName}
        </Box>
      </Tooltip>
    </ButtonBase>
  );
};

export default OrganisationLogoHeader;
